import React from "react";
import classNames from "classnames";

import {
  setLocalItem,
  getLocalItem,
} from "utils/localdb";
import Icon from "components/Library/Icon";
import Ad from "components/Library/Ad";

import styles from "./CookieWarning.css";

export default class CookieWarning extends React.Component {
  constructor(props) {
    super(props);
    this.elementId = "ad-cookie-warning";
    this.onClose = this._onClose.bind(this);
    this.onSlotRenderEnded = this._onSlotRenderEnded.bind(this);
    this.state = {
      isVisible: false,
      seenCookieWarning: false,
    };
  }

  componentDidMount() {
    this.setState({ seenCookieWarning: getLocalItem("seenCookieWarning") });
  }

  _onSlotRenderEnded({ isEmpty }) {
    if (!isEmpty) {
      this.setState({
        isVisible: true,
      });
    }
  }

  _onClose() {
    setLocalItem("seenCookieWarning", true, { expires: 30 });
    this.setState({
      isVisible: false,
    });
  }

  render() {
    if (this.state.seenCookieWarning) return null;

    return (
      <div className={classNames(styles.root, { [styles.isActive]: this.state.isVisible })}>
        <div className={styles.adSlot}>
          <Ad
            adUnit="cookie"
            outOfPage={true}
            id={this.elementId}
            onSlotRenderEnded={this.onSlotRenderEnded}
            renderWhenViewable={false}
          />
        </div>

        <div className={styles.message}>
          <span>This site uses cookies to enhance your reading experience. By using this site, you consent to our use of cookies.</span>
          <span className={styles.okay} onClick={this.onClose}>Okay</span>
        </div>
        <button onClick={this.onClose} className={styles.closeButton}>
          <Icon name="close" className={styles.closeIcon} />
        </button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Library/CookieWarning/CookieWarning.js